import * as Redux from 'redux';
import { IActionCreator } from '../../../interfaces/IActionCreator';
import { Keys } from './types';
import { invokeApi } from '../../../networking/invoker';
import { birthday } from '../../../../model/birthday';

export interface IActions {
    loadBirthdays: (yyyymmdd: string) => Promise<Array<birthday>>;
}

// function parseQueryStringParameters(yyyymmdd?: string, page?: number, take?: number) {
//     let parsed = ``
//     if (yyyymmdd) {
//         parsed = parsed.concat(`?`);
//         if (yyyymmdd) {
//             parsed = parsed.concat(`yyyymmdd=${yyyymmdd}`);
//         }
//     }
//     return parsed;
// }

export const actionCreator: IActionCreator<IActions> = (dispatch: Redux.Dispatch<any>): IActions => {
    return {
        loadBirthdays: (yyyymmdd?: string) => {
            return new Promise((res, rej) => {
                dispatch({
                    type: Keys.LOAD,
                    payload: invokeApi({
                        path: '/api/ContactsBirthday/neardate/' + yyyymmdd,
                        method: 'GET',
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        return resp;
                    })
                })
            });
        },
    }
}